var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0DBA78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84992 16.6663C9.62562 16.6662 9.4083 16.5814 9.23484 16.4266L6.33428 13.8384C5.93767 13.4631 5.88696 12.8123 6.21983 12.3696C6.55271 11.9268 7.14847 11.8527 7.56443 12.2023L9.81107 14.2051L16.2855 7.71001C16.5289 7.39483 16.9181 7.26214 17.283 7.36992C17.6479 7.47771 17.9222 7.80637 17.986 8.21229C18.0499 8.61821 17.8916 9.02758 17.5804 9.2615L10.5103 16.3842C10.3314 16.5668 10.0951 16.6678 9.84992 16.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTic);
export default __webpack_public_path__ + "static/media/greenTic.e0f6898b9a985e5a51b22bbf6297c14b.svg";
export { ForwardRef as ReactComponent };